import './style/AppNav.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';
import banner from '../images/banner.png';

function AppNav(props) {    
    const location = useLocation();
    const navigate = useNavigate();
    const paths = ['/arena', '/tests', '/stats'];
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const nameRef = useRef(null);
    const userName = props.user ? props.user.first_name + ' ' + props.user.last_name : '';
    
    const handleLogout = async () => {
        await supabase.auth.signOut();
        props.setUser(null);
        navigate('/');
    }

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target) && nameRef.current && !nameRef.current.contains(e.target)) {setDropdownOpen(false);}
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={'app-nav ' + (paths.includes(location.pathname) ? 'page' : '')}>
            <div className='nav-logo'>
                <img src={banner} alt='πPrep' className='nav-banner' onClick={() => navigate('/')} />
            </div>
            <div className='options'>
                <Link to={props.user ? '/arena' : '/login'} className={location.pathname.includes('/arena') ? 'active' : ''}>Arena</Link>
                <Link to={props.user ? '/tests' : '/login'} className={location.pathname.includes('/tests') ? 'active' : ''}>Tests</Link>
            </div>
            <div className='user'>
                <span className='user-name' ref={nameRef} onClick={() => setDropdownOpen(!dropdownOpen)}>{userName}</span>
                <div className={`user-dropdown${dropdownOpen ? ' open' : ''}`} ref={dropdownRef}>
                    <span onClick={handleLogout}>Sign Out</span>
                </div>
            </div>
        </div>
    );
}

export default AppNav;